/* Purty Body — compact Kaching bundle variants
   Do not disable or replace Kaching's native inputs. */

(function () {
  'use strict';

  const selectors = {
    bundle: '.kaching-bundles',
    variants: '.kaching-bundles__bar-variants',
    wrapper: '.kaching-bundles__bar-variant-selector-wrapper',
    option: '.kaching-bundles__bar-variant-option',
    eventTarget: 'kaching-bundles-block'
  };

  let observer;
  let updateQueued = false;

  function element(tag, className, text) {
    const node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function setOpenState(variants, open, count) {
    variants.classList.toggle('purty-mix-open', open);

    const button = variants.querySelector('.purty-mix-toggle');
    const buttonText = button?.querySelector('.purty-mix-toggle__text');
    const buttonIcon = button?.querySelector('.purty-mix-toggle__icon');
    const masterSizeLabel = variants.querySelector('.purty-size-label');
    const masterColourLabel = variants.querySelector('.purty-colour-label');

    if (button) button.setAttribute('aria-expanded', String(open));
    if (buttonText) buttonText.textContent = open ? 'Use one size & colour' : 'Mix colours & sizes';
    if (buttonIcon) buttonIcon.textContent = open ? '−' : '+';
    if (masterSizeLabel) {
      masterSizeLabel.textContent = open ? 'Pair 1 size' : `Size for all ${count}`;
    }
    if (masterColourLabel) {
      masterColourLabel.textContent = open ? 'Pair 1 colour' : `Colour for all ${count}`;
    }

    variants.querySelectorAll('.purty-extra-item').forEach((wrapper) => {
      wrapper.setAttribute('aria-hidden', String(!open));
    });
  }

  function removeGeneratedUi(variants) {
    variants.querySelectorAll('.purty-generated').forEach((node) => node.remove());
    variants.querySelectorAll('.purty-master-item, .purty-extra-item').forEach((wrapper) => {
      wrapper.classList.remove('purty-master-item', 'purty-extra-item');
      wrapper.removeAttribute('aria-hidden');
    });
    variants.classList.remove('purty-variants-enhanced', 'purty-mix-open');
    delete variants.dataset.purtyVariantCount;
  }

  function enhanceVariantGroup(variants) {
    const wrappers = Array.from(variants.querySelectorAll(`:scope > ${selectors.wrapper}`));
    const count = wrappers.length;

    if (count < 2) return;

    const alreadyReady =
      variants.dataset.purtyVariantCount === String(count) &&
      variants.querySelector('.purty-mix-toggle') &&
      wrappers[0].querySelector('.purty-size-label');

    if (alreadyReady) return;

    const wasOpen = variants.classList.contains('purty-mix-open');
    removeGeneratedUi(variants);

    variants.classList.add('purty-variants-enhanced');
    variants.dataset.purtyVariantCount = String(count);

    const master = wrappers[0];
    const masterOptions = master.querySelectorAll(selectors.option);
    master.classList.add('purty-master-item');

    if (masterOptions[0]) {
      const sizeLabel = element('span', 'purty-generated purty-control-label purty-size-label', `Size for all ${count}`);
      masterOptions[0].prepend(sizeLabel);
    }

    if (masterOptions[1]) {
      const colourLabel = element('span', 'purty-generated purty-control-label purty-colour-label', `Colour for all ${count}`);
      masterOptions[1].prepend(colourLabel);
    }

    wrappers.slice(1).forEach((wrapper, index) => {
      wrapper.classList.add('purty-extra-item');
      const options = wrapper.querySelectorAll(selectors.option);

      if (options[0]) {
        const sizeLabel = element(
          'span',
          'purty-generated purty-control-label purty-pair-label',
          `Pair ${index + 2} size`
        );
        options[0].prepend(sizeLabel);
      }

      if (options[1]) {
        const pairLabel = element(
          'span',
          'purty-generated purty-control-label purty-pair-label',
          `Pair ${index + 2} colour`
        );
        options[1].prepend(pairLabel);
      }
    });

    const toggle = element('button', 'purty-generated purty-mix-toggle');
    toggle.type = 'button';
    toggle.setAttribute('aria-expanded', 'false');

    const toggleText = element('span', 'purty-mix-toggle__text', 'Mix colours & sizes');
    const toggleIcon = element('span', 'purty-mix-toggle__icon', '+');
    toggleIcon.setAttribute('aria-hidden', 'true');
    toggle.append(toggleText, toggleIcon);

    master.insertAdjacentElement('afterend', toggle);

    toggle.addEventListener('click', function () {
      setOpenState(variants, !variants.classList.contains('purty-mix-open'), count);
    });

    setOpenState(variants, wasOpen, count);
  }

  function enhanceAll() {
    document.querySelectorAll(`${selectors.bundle} ${selectors.variants}`).forEach(enhanceVariantGroup);
  }

  function scheduleEnhancement() {
    if (updateQueued) return;
    updateQueued = true;

    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        updateQueued = false;
        enhanceAll();
        attachKachingEvents();
      }, 0);
    });
  }

  function attachKachingEvents() {
    document.querySelectorAll(selectors.eventTarget).forEach((block) => {
      if (block.dataset.purtySharedVariantListeners === 'true') return;
      block.dataset.purtySharedVariantListeners = 'true';

      ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach((eventName) => {
        block.addEventListener(eventName, scheduleEnhancement);
      });
    });
  }

  function initialise() {
    const bundle = document.querySelector(selectors.bundle);

    if (!bundle) {
      window.setTimeout(initialise, 300);
      return;
    }

    enhanceAll();
    attachKachingEvents();

    observer = new MutationObserver(scheduleEnhancement);
    observer.observe(bundle, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();